import { Tab } from '@mui/icons-material'
import cn from 'classnames'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Link from '../common/util/input/Link'
import ContentTabs from '../contenttabs/ContentTabs'
import FixedSearchComponent from '../searchitems/FixedSearchComponent'
import TabItem from '../tabitem/TabItem'
import { useSharedState } from '../waxplorer/Waxplorer'
import { Button } from '@nextui-org/react'
import FixedDropsList from '../drops/FixedDropsList'

function SearchPopup(props) {
    const asset = props['asset']

    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const action = props['searchType']
    const includeTubes = props['includeTubes']
    const includeDrops = props['includeDrops']

    const {
        schema,
        collection,
        name,
        owner,
        templateId,
        attributeName,
        attributeValue,
    } = asset

    const [tabKey, setTabKey] = useState('listings')

    const term = templateId ? templateId : name ? escape(name) : ''

    let link = ''
    let orderBy = 'price_asc'
    let title = ''
    let search = action

    const searchAttributes = attributeName && attributeValue
    const attributesStr = searchAttributes
        ? `&attributes=${escape(attributeName)}:${escape(attributeValue)}`
        : `${templateId ? `&template_id=${templateId}` : ''}`
    const term2 = searchAttributes ? '' : term

    switch (action) {
        case 'cheapest':
            link = `/market/?term=${term ? term : ''}&collection=${
                collection ? collection : ''
            }&schema=${schema ? schema : ''}&order_by=${orderBy}&limit=100${
                templateId ? `&template_id=${templateId}` : ''
            }&exact_search=true&search_type=cheapest`
            title = t('search.cheapest')
            break
        case 'listings':
            link = `/market/?term=${term2 ? term2 : ''}&collection=${
                collection ? collection : ''
            }&schema=${
                schema ? schema : ''
            }&order_by=${orderBy}&limit=100${attributesStr}&exact_search=true&search_type=listings`
            title = t('search.sales')
            break
        case 'active_sales':
            link = `/market/?term=${term ? term : ''}&collection=${
                collection ? collection : ''
            }&schema=${schema ? schema : ''}&order_by=${orderBy}&limit=100${
                templateId ? `&template_id=${templateId}` : ''
            }&owner=${owner ? owner : ''}&exact_search=true&search_type=sales`
            title = t('profile.active_sales')
            search = 'sales'
            break
        case 'cheapest_missing':
            link = `/market/?term=${term ? term : ''}&collection=${
                collection ? collection : ''
            }&schema=${schema ? schema : ''}&order_by=${orderBy}&limit=100${
                templateId ? `&template_id=${templateId}` : ''
            }&owner=${owner ? owner : ''}${
                includeTubes ? '' : '&include_tubes=false'
            }&exact_search=true&search_type=cheapest_missing`
            title = t('search.sales')
            break
        case 'sales':
            link = `/market/?term=${term ? term : ''}&collection=${
                collection ? collection : ''
            }&schema=${schema ? schema : ''}&order_by=date_desc&limit=100${
                templateId ? `&template_id=${templateId}` : ''
            }&exact_search=true&search_type=sales&tab=sales`
            orderBy = 'date_desc'
            title = t('profile.recent_sells')
            break
    }

    const cancel = () => {
        callBack(false)
    }

    return (
        <div
            className={cn(
                'relative z-40 w-11/12 justify-center h-9/10 shadow-xl',
                'text-sm dark:text-white text-black p-2',
                'dark:!bg-paper bg-zinc-200 rounded-2xl m-auto top-10',
            )}
        >
            {includeDrops ? (
                <div className={'relative h-9/10 overflow-y-auto InsideScroll'}>
                    <ContentTabs
                        tabKey={tabKey}
                        onSelect={(k) => setTabKey(k)}
                        bg={'bg-transparent'}
                    >
                        <Tab
                            eventKey="listings"
                            title={
                                <TabItem
                                    target={'listings'}
                                    tabKey={tabKey}
                                    title={t('search.sales')}
                                />
                            }
                        >
                            {tabKey === 'listings' ? (
                                <>
                                    <div
                                        className={
                                            'flex justify-between h-10 py-2'
                                        }
                                    >
                                        <Link href={link}>
                                            <div
                                                onClick={cancel}
                                                className={
                                                    'flex cursor-pointer'
                                                }
                                            >
                                                {t('search.open_full_search')}{' '}
                                                <img
                                                    className={'ml-2 w-5 h-5'}
                                                    src="/search.svg"
                                                    alt=""
                                                />
                                            </div>
                                        </Link>
                                    </div>
                                    <div className={'relative h-9/10'}>
                                        <FixedSearchComponent
                                            {...props}
                                            id={'Fixed1'}
                                            searchSettings={{
                                                owner: {
                                                    value: [
                                                        'assets',
                                                        'active_sales',
                                                        'staked',
                                                        'choobed',
                                                        'cheapest_missing',
                                                    ].includes(action)
                                                        ? owner
                                                        : '',
                                                },
                                                includeTubes: {
                                                    value: includeTubes,
                                                },
                                                search_type: { value: search },
                                                collection: {
                                                    value: collection,
                                                },
                                                schema: {
                                                    value: schema ? schema : '',
                                                },
                                                name: {
                                                    value: searchAttributes
                                                        ? ''
                                                        : name,
                                                },
                                                exact_search: { value: true },
                                                templateId: {
                                                    value: templateId,
                                                },
                                                order_by: { value: orderBy },
                                                attributes: {
                                                    value: searchAttributes
                                                        ? `${escape(
                                                              attributeName,
                                                          )}:${escape(
                                                              attributeValue,
                                                          )}`
                                                        : '',
                                                },
                                                limit: {
                                                    value:
                                                        action ===
                                                        'cheapest_missing'
                                                            ? 100
                                                            : 12,
                                                    fixed: true,
                                                },
                                            }}
                                            userName={userName}
                                        />
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </Tab>
                        <Tab
                            eventKey="drops"
                            title={
                                <TabItem
                                    target={'drops'}
                                    tabKey={tabKey}
                                    title={t('navigation.drops')}
                                />
                            }
                        >
                            {' '}
                            {tabKey === 'drops' ? (
                                <>
                                    <div className={'relative h-9/10'}>
                                        <FixedDropsList
                                            {...props}
                                            id={'Fixed1'}
                                            searchSettings={{
                                                owner: {
                                                    value: [
                                                        'assets',
                                                        'active_sales',
                                                        'staked',
                                                        'choobed',
                                                        'cheapest_missing',
                                                    ].includes(action)
                                                        ? owner
                                                        : '',
                                                },
                                                market: 'all',
                                                collection: {
                                                    value: collection,
                                                },
                                                schema: {
                                                    value: schema ? schema : '',
                                                },
                                                name: {
                                                    value: searchAttributes
                                                        ? ''
                                                        : name,
                                                },
                                                exact_search: { value: true },
                                                templateId: {
                                                    value: searchAttributes
                                                        ? ''
                                                        : templateId,
                                                },
                                                order_by: { value: orderBy },
                                                attributes: {
                                                    value: searchAttributes
                                                        ? `${escape(
                                                              attributeName,
                                                          )}:${escape(
                                                              attributeValue,
                                                          )}`
                                                        : '',
                                                },
                                                limit: {
                                                    value:
                                                        action ===
                                                        'cheapest_missing'
                                                            ? 100
                                                            : 12,
                                                    fixed: true,
                                                },
                                            }}
                                            userName={userName}
                                        />
                                    </div>
                                </>
                            ) : (
                                ''
                            )}
                        </Tab>
                    </ContentTabs>
                </div>
            ) : (
                <>
                    <div className={'flex justify-between h-20 py-2 mb-2'}>
                        <Link href={link}>
                            <Button
                                radius="sm"
                                variant="bordered"
                                color="warning"
                                onClick={cancel}
                                className={'flex cursor-pointer'}
                            >
                                SHOW FULL PAGE
                            </Button>
                        </Link>
                    </div>
                    <div className={'relative h-9/10'}>
                        <FixedSearchComponent
                            {...props}
                            id={'Fixed1'}
                            searchSettings={{
                                owner: {
                                    value: [
                                        'assets',
                                        'active_sales',
                                        'staked',
                                        'choobed',
                                        'cheapest_missing',
                                    ].includes(action)
                                        ? owner
                                        : '',
                                },
                                includeTubes: { value: includeTubes },
                                search_type: { value: search },
                                collection: { value: collection },
                                schema: { value: schema ? schema : '' },
                                exact_search: { value: true },
                                templateId: { value: templateId },
                                order_by: { value: orderBy },
                                attributes: {
                                    value: searchAttributes
                                        ? `${escape(attributeName)}:${escape(
                                              attributeValue,
                                          )}`
                                        : '',
                                },
                                limit: {
                                    value:
                                        action === 'cheapest_missing'
                                            ? 100
                                            : 12,
                                    fixed: true,
                                },
                            }}
                            userName={userName}
                        />
                    </div>
                </>
            )}
        </div>
    )
}

export default SearchPopup
